import { useSite } from "@/context/SiteContext";
import AboutSection from "@/components/site/AboutSection";
import LegalSection from "@/components/site/LegalSection";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import ServicesSection from "@/components/site/ServicesSection";
import PortfolioSection from "@/components/site/PortfolioSection";
import ArticlesSection from "@/components/site/ArticlesSection";
import FaqSection from "@/components/site/FaqSection";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";
import ChatWidget from "@/components/site/ChatWidget";
import { ErrorBoundary } from "@/components/ErrorBoundary";

export default function Landing() {
  const { site, t } = useSite();
  if (!site) return <div className="grid min-h-screen place-items-center font-mono text-sm text-slate-500">{t("loading")}</div>;
  return (
    <div data-testid="landing-page">
      <Navbar />
      <Hero profile={site.profile} />
      <AboutSection profile={site.profile} />
      <ServicesSection services={site.services} />
      <PortfolioSection items={site.portfolio} />
      <LegalSection items={site.profile.legal} />
      <ArticlesSection articles={site.articles} />
      <FaqSection faqs={site.faqs} />
      <LeadForm profile={site.profile} />
      <Footer profile={site.profile} />
      <ErrorBoundary compact><ChatWidget /></ErrorBoundary>
    </div>
  );
}
